import { useFormContext } from "react-hook-form";
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

interface FormTextareaProps {
	name: string;
	label?: string;
	placeholder?: string;
	required?: boolean;
	rows?: number;
	disabled?: boolean;
}

export function FormTextarea({
	name,
	label,
	placeholder,
	required,
	rows = 4,
	disabled,
}: FormTextareaProps) {
	const form = useFormContext();

	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					{label && <FormLabel required={required}>{label}</FormLabel>}
					<FormControl>
						<Textarea
							{...field}
							placeholder={placeholder}
							rows={rows}
							disabled={disabled}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	);
}
